import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter, NgZone } from '@angular/core';

import { each, filter, find } from 'lodash';

@Component({
  selector: 'fihe-filter-selection',
  templateUrl: './filter-selection.component.html',
  styleUrls: ['./filter-selection.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSelectionComponent implements OnInit {

  @Input('filters') filters;
  @Input('meta') meta;
  @Output() changeIt = new EventEmitter();

  selection;

  constructor(private ref: ChangeDetectorRef,private zone: NgZone) {

   }

  ngOnInit() {
    this.cherryPic();
    this.ref.detectChanges();
  }


  ngOnChanges(changes){

    if ( changes.filters && !changes.filters.firstChange ) {
      this.cherryPic();
      this.ref.detectChanges();
    }
    if ( changes.meta && !changes.meta.firstChange ) {
      this.ref.detectChanges();
    }
  }


  cherryPic(){
    this.selection = [];
    each( this.filters , (_cat) => {
      if ( _cat.form_type == 'checkbox' || _cat.form_type == 'radio' ) {
        each( _cat.items , (_values) => {
          if ( _values.checked && _values.value != -1 ) {
            this.selection.push({
              "label" : _values.label,
              "value" : _values.value,
              "index_field" : _cat.index_field
            });
          }
        })
      } else if (_cat.form_type == 'geo')  {
        if (_cat.text_value && _cat.text_value.length > 0) {
          this.selection.push({
            "label" : find( _cat.items , { checked: true } ).label,
            "index_field" : _cat.index_field
          });
        }
      }
    } );


  }

  all(){
    each(this.selection,(e) => this.deselect(e,true) );
    this.changeIt.emit();
  }

  deselect(_item,_silent = false){
    var select = find(this.filters , {index_field : _item.index_field});

    if ( select ) {

      if ( select.form_type == 'checkbox' || select.form_type == 'radio' ) {

        each( select.items , (_val) => {

          if (_val.value == _item.value) {
            _val.checked = false;
          }
        });

        // Check if non is selected, then select -1 value
        var selected = filter(select.items , {checked: true});
        if ( !selected || selected.length == 0 ) {
          each( select.items , (_val) => {
            if (_val.value == -1) {
              _val.checked = true;
            }
          });
        }
      } else if (select.form_type == 'geo') {
        select.text_value = '';
      }
    }

    if (!_silent ) {
      this.changeIt.emit();
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/filter-selection/filter-selection.component.ts